import * as React from "react";
import { IconProps } from "common/assets/icons/types";

export const RadioUncheckedIcon: React.FC<IconProps> = ({
  color = "#22282f",
  altText,
}) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      {altText && <title id="uncheckedId">{altText}</title>}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <g transform="translate(6 6)" fill={color}>
          <circle fillRule="nonzero" opacity=".12" cx="9.75" cy="9.75" r="9" />
          <path d="M9.75 1.5a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM0 9.75C0 4.365 4.365 0 9.75 0s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S0 15.135 0 9.75Z" />
        </g>
      </g>
    </svg>
  );
};
